// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2cYz4","signatureBlock":"Footer_signatureBlock__3TsPL","signature":"Footer_signature__2JIfF"};